import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Header } from "./components/Header";
import { Hero } from "./components/Hero";
import { Services } from "./components/Services";
import { About } from "./components/About";
import { Portfolio } from "./components/Portfolio";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";
import { QuoteForm } from "./components/QuoteForm";
import { Founders } from "./components/Founders";
import { ServicesPage } from "./components/ServicesPage";
import { AboutPage } from "./components/AboutPage";
import { PortfolioPage } from "./components/PortfolioPage";
import { ContactPage } from "./components/ContactPage";
import { QuotePage } from "./components/QuotePage";
import { CareersPage } from "./components/CareersPage";
import { Toaster } from "./components/ui/sonner";

const Layout = ({ children }) => {
  const location = useLocation();
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);
  return (
    <div className="min-h-screen bg-background text-foreground antialiased">
      <Header />
      <main>{children}</main>
      <Footer />
      <Toaster theme="dark" position="top-center" richColors />
    </div>
  );
};

const Home = () => (
  <Layout>
    <Hero />
    <About />
    <Services />
    <Portfolio />
    <QuoteForm />
    <Contact />
  </Layout>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/founders" element={<Layout><Founders /></Layout>} />
          <Route path="/services" element={<Layout><ServicesPage /></Layout>} />
          <Route path="/about" element={<Layout><AboutPage /></Layout>} />
          <Route path="/portfolio" element={<Layout><PortfolioPage /></Layout>} />
          <Route path="/contact" element={<Layout><ContactPage /></Layout>} />
          <Route path="/quote" element={<Layout><QuotePage /></Layout>} />
          <Route path="/careers" element={<Layout><CareersPage /></Layout>} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
